import type { Navigation } from '../../types/navigation'

export interface FlatPage {
  id: string
  title: string
  path?: string
  href?: string
  segment: string
  slashes?: string[]
  keywords?: string[]
  description?: string
}

function titleToSlash(title: string): string {
  return `/${title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')}`
}

export function flattenNavigation(
  items: Navigation,
  parentSegment?: string,
): FlatPage[] {
  const pages: FlatPage[] = []

  for (const item of items) {
    if (item.kind === 'header' || item.kind === 'divider') continue

    if (item.children && item.children.length > 0) {
      pages.push(...flattenNavigation(item.children, item.segment))
      continue
    }

    if (!item.title) continue

    const segment =
      parentSegment && item.segment ? `${parentSegment}/${item.segment}` : item.segment || ''
    const path = item.href ? undefined : segment ? `/${segment}` : undefined
    if (!path && !item.href) continue

    pages.push({
      id: item.href || path || item.title,
      title: item.title,
      path,
      href: item.href,
      segment,
      slashes: item.slashes?.length ? item.slashes : [titleToSlash(item.title)],
      keywords: item.keywords,
      description: item.description,
    })
  }

  return pages
}
